import { render, staticRenderFns } from "./EditLockForm.vue?vue&type=template&id=b0b4f478&scoped=true&"
import script from "./EditLockForm.vue?vue&type=script&lang=js&"
export * from "./EditLockForm.vue?vue&type=script&lang=js&"
import style0 from "./EditLockForm.vue?vue&type=style&index=0&id=b0b4f478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b4f478",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VBtn,VForm,VIcon,VTextField,VTextarea})
